import React, { useState } from "react";
import "../../styles/login.css";

function LoginForm({ email, handleLoginSubmit, setEmail }) {
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    setSubmitting(true);
    try {
      await handleLoginSubmit(e);
    } finally {
      // Keep button locked briefly so the user sees feedback even on fast paths.
      setTimeout(() => setSubmitting(false), 800);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-aside" aria-hidden="true">
        <div className="login-aside-inner">
          <div className="login-brand">
            <span>CMBS</span><span className="login-brand-accent">DLT</span>
          </div>
          <p className="login-tagline">Distributed-ledger noteholder platform for commercial mortgage-backed securities.</p>
          <ul className="login-bullets">
            <li><i className="bi bi-shield-check" /> SOC-grade access controls</li>
            <li><i className="bi bi-clock-history" /> Immutable audit history</li>
            <li><i className="bi bi-bank2" /> Built for legal & compliance teams</li>
          </ul>
          <div className="login-foot">&copy; {new Date().getFullYear()} CMBSDLT</div>
        </div>
      </div>

      <div className="login-pane">
        <form onSubmit={onSubmit} className="login-form fade-in" aria-busy={submitting}>
          <h1 className="login-title">Welcome back</h1>
          <p className="login-sub">Sign in with your firm email. We&apos;ll email you a one-time code.</p>

          <label className="login-label" htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="you@firm.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            required
          />

          <button type="submit" className="login-submit" disabled={submitting || !email}>
            {submitting ? (
              <>
                <span className="spinner" /> Sending code…
              </>
            ) : (
              <>Continue <i className="bi bi-arrow-right" /></>
            )}
          </button>

          <div className="login-terms">
            <a href="#">Privacy</a><span>•</span><a href="#">Terms</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
